import React from 'react';
import { Link } from 'gatsby';
import styled from '@emotion/styled';
import { colors, device } from './layout/GlobalStyles';
import { StaticImage } from 'gatsby-plugin-image';
import { Button } from './layout/StyledComponents';
import { SlantedPicture } from './SlantedPicture';

const StyledHomeVideo = styled.div`
    position: relative;
    margin: 2em 0em 0em;
    button {
        margin: 2em 0em;
    }
    .image-container {
        cursor: pointer;
    }
    .video-container {
        display: flex;
        justify-content: center;
        iframe {
            width: 92vw;
            border-radius: 20px;
        }
    }
    .text-container {
        position: relative;
        max-width: 100vw;
    }
    h4 {
        margin: 0.5em 0em;
    }
    @media ${device.tablet} {
        .video-container {
            display: flex;
            justify-content: center;
            iframe {
                width: 550px;
                height: 340px;
            }
        }
    }
    @media ${device.laptop} {
        .video-container {
            iframe {
                width: 600px;
                height: 440px;
            }
        }
        .text-container {
            button {
                margin-top: 0em;
            }
            h4 {
                font-size: 38px;
            }
        }
    }
    @media ${device.laptopL} {
        margin: 2em auto 0em;
        max-width: 1360px;
        .text-container {
            width: 700px;
        }
    }
    @media ${device.desktop} {
        margin: 2em auto 6em;
        max-width: 1560px;
        display: flex;
        justify-content: center;
        .text-container {
            width: 700px;

            margin-right: 4em;
            button {
                margin-top: 0em;
            }
            h4 {
                font-size: 58px;
            }
        }
    }
`;

export const HomeVideo: React.FC = () => {
    return (
        <StyledHomeVideo>
            <SlantedPicture>
                <div className="flex-container">
                    <a
                        href="https://www.youtube.com/watch?v=ChKsot2eEok"
                        rel="noreferrer"
                        target="_blank"
                    >
                        <div style={{ position: 'relative' }} className="video-container">
                            <iframe
                                className="shadow"
                                width="560"
                                height="315"
                                src="https://www.youtube.com/embed/XXNoac1BtLY"
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                            {/* <iframe  placeholder="none" width="560" className="masked-image" height="515" src="https://www.youtube.com/embed/Wc0-IX20Drs" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" ></iframe> */}
                        </div>
                    </a>
                    <div className="text-container">
                        <h4>Affordable Membership for all</h4>
                        <p>
                            At SmileCraft, it pays to be a member of our dental family. Whether you
                            have limited or no insurance you'll receive premium preventive care,
                            discounts on dental treatments, and much more when you become a member.
                        </p>
                        <Link to="/membership-plans/">
                            <Button color="blue">Enroll Now</Button>
                        </Link>
                    </div>
                </div>
            </SlantedPicture>
        </StyledHomeVideo>
    );
};
